export class SurveyPeriodStateModel {
	state: string;
	notes: string;
}

export interface SurveyPeriodStateArgument {
	notes: string;
}
